
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"46","height":"46","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"46","height":"46","rx":"8","fill":"url(#paint0_linear)"}}),_c('path',{attrs:{"d":"M23.594 14.82c0-.81-1.09-1.126-1.582-.458-4.325 6.364 1.863 6.645 1.863 9.739 0 1.265-1.055 2.285-2.285 2.25-1.266 0-2.215-1.02-2.215-2.25v-3.024c0-.773-.95-1.125-1.477-.563C16.95 21.5 16 23.187 16 25.227a6.752 6.752 0 006.75 6.75c3.691 0 6.75-3.024 6.75-6.75 0-5.977-5.906-6.786-5.906-10.407z","fill":"#fff"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear","x1":"0","y1":"0","x2":"51.265","y2":"6.904","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#01A48B"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#41BB2E"}})])])])
          )
        }
      }
    